import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { IApiEpBillingProduct } from "@smp/api";

import { useEpBillingFeature } from "@/hooks/use_ep_billing_feature";
import { useHumanizer } from "@/hooks/use_humanizer";

export const useProductDescription = ({
  product,
}: {
  product: IApiEpBillingProduct;
}) => {
  const { feature } = useEpBillingFeature({
    req: {
      path: {
        id: product.type === "feature-subscription" ? product.feature : 0,
      },
    },
    useQueryOptions: { enabled: product.type === "feature-subscription" },
  });

  const { humanizeBillingPlanId, humanizeFeatureName, humanizePeriodUnit } =
    useHumanizer();

  const { i18n } = useLingui();

  let description = "";

  if (product.type === "feature-subscription" && feature) {
    description = `${humanizeFeatureName(feature.name)}`;
  }

  if (product.type === "posts-package") {
    description = i18n._(t`Package of ${product.amount} posts`);
  }

  if (product.type === "plan-product") {
    description = i18n._(
      t`${humanizeBillingPlanId(product.plan.id)} plan for ${humanizePeriodUnit(
        product.period_units,
        product.period_length,
      )}`,
    );
  }

  return { description };
};
